/* Hamada Supplements — homepage v3 behaviour (countdowns, slider, tabs, rails) */
(function () {
  'use strict';

  /* ---- Countdowns ----
     data-end   : "YYYY-MM-DD HH:MM" or "DD/MM/YYYY HH:MM" (Cairo time). Used while it is in the future.
     data-cycle : days, or "month" for the end of the current month. When no end date is set (or it has passed), the timer restarts
                  every N days at midnight Cairo time, so all visitors see the same clock. */
  var ANCHOR = Date.parse('2026-01-01T00:00:00+02:00');

  // Accepts "2026-10-31 23:59" or "31/10/2026 23:59" (time optional, defaults to 23:59), Cairo time
  function parseDate(raw) {
    var m = raw.replace(/[٠-٩]/g, function (c) { return c.charCodeAt(0) - 0x660; })
               .match(/^(\d{1,4})[-\/.](\d{1,2})[-\/.](\d{1,4})(?:[ T]+(\d{1,2}):(\d{2}))?/);
    if (!m) return NaN;
    var y, mo, d;
    if (m[1].length === 4) { y = +m[1]; mo = +m[2]; d = +m[3]; } else { d = +m[1]; mo = +m[2]; y = +m[3]; }
    var hh = m[4] !== undefined ? +m[4] : 23, mm = m[5] !== undefined ? +m[5] : 59;
    var iso = y + '-' + ('0' + mo).slice(-2) + '-' + ('0' + d).slice(-2) + 'T' + ('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2) + ':00+02:00';
    return Date.parse(iso);
  }

  function endFor(el) {
    var raw = (el.getAttribute('data-end') || '').trim();
    var now = Date.now();
    if (raw) {
      var t = parseDate(raw);
      if (!isNaN(t) && t > now) return t;
    }
    if (el.getAttribute('data-cycle') === 'month') {
      var d = new Date();
      return new Date(d.getFullYear(), d.getMonth() + 1, 1).getTime() - 1000;
    }
    var days = parseFloat(el.getAttribute('data-cycle')) || 0;
    if (days <= 0) return null;
    var cycle = days * 864e5;
    return now + (cycle - ((now - ANCHOR) % cycle));
  }

  var timers = [];
  document.querySelectorAll('[data-hs-countdown]').forEach(function (el) {
    timers.push({ el: el, end: endFor(el) });
  });

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Date.now();
    timers.forEach(function (t) {
      if (t.end && t.end <= now) t.end = endFor(t.el);
      if (!t.end) { t.el.classList.add('is-done'); return; }
      var s = Math.max(0, Math.floor((t.end - now) / 1000));
      var map = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(map).forEach(function (k) {
        var node = t.el.querySelector('[data-' + k + ']');
        if (node) node.textContent = pad(map[k]);
      });
    });
  }
  if (timers.length) { tick(); setInterval(tick, 1000); }

  /* ---- Hero slider ---- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-hs-slider]').forEach(function (root) {
    var slides = root.querySelectorAll('.hs-slide');
    var dots = root.querySelectorAll('.hs-slider__dots button');
    if (slides.length < 2) return;
    var cur = 0, timer = null;
    var delay = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
    function go(i) {
      slides[cur].classList.remove('is-active'); if (dots[cur]) dots[cur].classList.remove('is-active');
      cur = (i + slides.length) % slides.length;
      slides[cur].classList.add('is-active'); if (dots[cur]) dots[cur].classList.add('is-active');
    }
    function auto() {
      if (!delay || reduce) return;
      clearInterval(timer);
      timer = setInterval(function () { go(cur + 1); }, delay);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); auto(); }); });
    var prev = root.querySelector('.hs-slider__nav--prev'), next = root.querySelector('.hs-slider__nav--next');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); auto(); });
    if (next) next.addEventListener('click', function () { go(cur + 1); auto(); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { var rtl = document.documentElement.dir === 'rtl'; go(cur + ((dx < 0) !== rtl ? 1 : -1)); auto(); }
    });
    auto();
  });

  /* ---- Tabs ---- */
  document.querySelectorAll('[data-hs-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.hs-tab');
    var panels = root.querySelectorAll('[data-hs-panel]');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
      });
    });
  });

  /* ---- Product rails (prev / next) ---- */
  document.querySelectorAll('[data-hs-rail]').forEach(function (wrap) {
    var rail = wrap.querySelector('.hs-rail');
    if (!rail) return;
    function step(dir) {
      var rtl = getComputedStyle(rail).direction === 'rtl';
      var amount = rail.clientWidth * 0.8 * dir * (rtl ? -1 : 1);
      rail.scrollBy({ left: amount, behavior: reduce ? 'auto' : 'smooth' });
    }
    var p = wrap.querySelector('.hs-rail-btn--prev'), n = wrap.querySelector('.hs-rail-btn--next');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  });

  /* ---- Brand slider: auto-scrolls, drag with the mouse, swipe on touch, arrows ---- */
  document.querySelectorAll('[data-hs-marq]').forEach(function (box) {
    var track = box.querySelector('.hs-marq__track');
    if (!track || track.children.length === 0) return;
    track.innerHTML += track.innerHTML; // two copies for a seamless loop
    var wrap = box.parentElement;
    var secs = parseFloat(box.getAttribute('data-speed')) || 45;
    var paused = false, resumeAt = 0, dragging = false, moved = false, startX = 0, startLeft = 0, last = 0;

    function half() { return track.scrollWidth / 2; }
    function loop() {
      var h = half();
      if (box.scrollLeft >= h) box.scrollLeft -= h;
      else if (box.scrollLeft <= 0) box.scrollLeft += h;
    }
    function hold(ms) { resumeAt = Date.now() + (ms || 2500); }

    function frame(t) {
      var dt = last ? Math.min(t - last, 64) : 16;
      last = t;
      if (!reduce && !paused && !dragging && Date.now() > resumeAt) {
        box.scrollLeft += (half() / (secs * 1000)) * dt;
        loop();
      }
      requestAnimationFrame(frame);
    }
    box.scrollLeft = 1;
    requestAnimationFrame(frame);

    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; dragging = false; box.classList.remove('is-dragging'); });
    box.addEventListener('touchstart', function () { hold(4000); }, { passive: true });
    box.addEventListener('scroll', function () { if (!dragging) loop(); }, { passive: true });

    box.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragging = true; moved = false; startX = e.clientX; startLeft = box.scrollLeft;
      box.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      box.scrollLeft = startLeft - dx;
      loop();
      startLeft = box.scrollLeft + dx;
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false; box.classList.remove('is-dragging'); hold();
    });
    box.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    box.addEventListener('dragstart', function (e) { e.preventDefault(); });

    wrap.querySelectorAll('.hs-marq-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        hold(3000);
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
        var target = box.scrollLeft + dir * box.clientWidth * 0.6;
        var h = half();
        if (target < 0) { box.scrollLeft += h; target += h; }
        if (target > h * 1.5) { box.scrollLeft -= h; target -= h; }
        box.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  });
})();
